import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import ListingContainer from "../../../containers/listing_container";
import {CLERK_API_URL} from "../../../constants/api_routes";
import ViewClerkUserDetails from "./view_user_details";
import CreateClerkUser from "./create_user";
import UpdateClerkUser from "./update_user";
import {Button, Header, Icon, Modal, Popup,Grid} from "semantic-ui-react";
import Loader from "../../universal/loader";
import ClerkLeaveRecord from "./record_leave";
import ChangeUserEmail from "../../auth/change_email";
import ChangePassword from "../../auth/change_password";

class Clerk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            userDeleteSelectedId: null,
            selectedClerk:undefined
        }
    }

    componentWillMount() {
        this.setState({action: 'listing'});
        this.props.getList(CLERK_API_URL);
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if(this.state.action === 'change_email' && nextState.action === "listing"){
            this.props.getList(CLERK_API_URL);
        }
    }

    handleView(row) {
        this.setState({action: 'view'});
        this.props.viewDetails(this.props.data.filter((e) => {
            return e.id === row;
        }));
    }

    handleEdit(row) {
        this.setState({action: 'update'});
        this.props.editDetails(this.props.data.filter((e) => {
            return e.id === row;
        }));
    }

    handleCreate() {
        this.setState({action: 'create'});
    }

    handleDelete(row) {
        this.props.deleteDetail(CLERK_API_URL, row);
        this.setState({showConfirm: false});
    }

    handleLeave(row) {
        this.setState({action:'record-leave',selectedClerk:row});
    }

    setListing = () => {
        this.setState({action: 'listing'});
    };

    handlePriceListView = () => {
      this.props.history.push('/clerk/price_list');
    };

    render() {
        const columns = [{
            Header: 'Name',
            accessor: 'name',
            filterable: true
        }, {
            Header: 'Email',
            accessor: 'email',
            filterable: true,
            Cell: ({original,value}) => (
                <div className="icon-button" onClick={() => {this.setState({ currentUserId:original['user_id'],currentUserEmail: value ,action:'change_email'})}}>
                    {value}
                </div>
            )
        }, {
            Header: 'Phone Number',
            accessor: 'mobile_number',
            filterable: true
        }, {
            Header: 'Address',
            accessor: 'address',
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).toUpperCase().indexOf(filter.value.toUpperCase()) >= 0 : true
            },
            className:'address-width',
            headerClassName:'address-width',
            filterable: true
            }, {
                id: 'dormant',
                Header: 'Status',
                accessor: d => { return d.dormant ? 'Dormant' : 'Active' },
                filterable: true
            }, {
            Header: 'Action',
            id: 'edit',
            accessor: 'id',
            className: 'clerk-address',
            headerClassName: 'clerk-address',
            Cell: ({value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                    <Button basic compact icon primary size='mini' onClick={(e) => this.handleEdit(value)}><Icon
                        name='edit'/>Edit</Button>
                    <Button basic compact icon color="teal" size='mini' onClick={(e) => this.handleLeave(value)}><Icon
                        name='calendar'/>Manage Leave</Button>
                    <Popup
                        trigger={<Button basic compact icon negative size='mini'><Icon name='user delete'/></Button>}
                        content={<Button negative content='Confirm toggle user dormant/active?'
                                         onClick={(e) => this.handleDelete(value)}/>}
                        on='click'
                        position='right center'
                        hideOnScroll
                    />
                </div>
            )
        }];

        return (<div className="listing-container">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={2}>
                            <Header content="Clerk Users" size='large' textAlign="left"/>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Button primary icon labelPosition='right' onClick={(e) => {
                                this.handleCreate()
                            }}>Add New Clerk <Icon name='plus'/>
                            </Button>
                        </Grid.Column>
                        <Grid.Column width={10} className="right-aligned">
                            <Button positive onClick={(e) => {
                                this.handlePriceListView();
                            }}>View Clerk Price List
                            </Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <div className="pad-top">
                    {this.props.isFetching && <Loader/>}
                    {!this.props.isFetching && this.props.data.length > 0 && <ReactTable
                        data={this.props.data}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        defaultPageSize={10}
                        noDataText="No Clerks Found"
                        minRows={0}
                    />}

                    <Modal size={this.state.action === 'view' ?"tiny":"large"} open={this.state.action !== "listing" && this.state.action !== 'record-leave'} onClose={(e) => {
                        this.setListing()
                    }}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                    this.setListing()
                                }}><Icon name="close"/></Button>
                            </div>
                            <Modal.Description style={{height:this.state.action === 'change_email' ?'350px':'auto'}}>
                                {this.state.action === 'view' &&
                                <ViewClerkUserDetails selectedObject={this.props.selectedObject}/>}
                                {this.state.action === 'update' &&
                                <UpdateClerkUser selectedObject={this.props.selectedObject}
                                                 onSuccess={this.setListing}/>}
                                {this.state.action === 'create' && <CreateClerkUser onSuccess={this.setListing}/>}
                                {this.state.action === 'change_email' && <Grid> <Grid.Column width={8}>
                    <ChangeUserEmail userId={this.state.currentUserId} userEmail = {this.state.currentUserEmail} onSuccess={this.setListing} userType={this.props.userRole  === 'admin' ? 'admin' : 'others'}/>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <ChangePassword userId={this.state.currentUserId} onSuccess={this.setListing} admin/>
                    </Grid.Column>
                </Grid>}
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>
                    {!this.props.isFetching && !(this.props.data.length > 0) &&
                    <div className='center'>No Available users. Add user?</div>}
                    {this.state.action === 'record-leave' && <ClerkLeaveRecord close={this.setListing} clerkId={this.state.selectedClerk}/>}
                </div>
            </div>
        );
    }

}

export default ListingContainer(Clerk);


// WEBPACK FOOTER //
// ./src/views/user/clerk/index.js